<template lang="pug">
.contentpage
    .header-area(v-if="areas.header && areas.header.length")
        section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
            Banner(v-if="section.key === 'banner'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
    .main-area(v-if="areas.main && areas.main.length")
        section.container.mx-auto(
            v-for="(section, index) in areas.main"
            :key="section.id"
            :class="section.key"
        )
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            Homepage(v-if="section.key === 'homepage'" :section="section")
            Mapbox(v-if="section.key === 'map'" :section="section")
            Form(v-if="section.key === 'form'" :section="section")
</template>

<script>
import Page from "@/views/Page";

import Heading from "@/components/Heading";
import Banner from "@/components/Banner";
import Slider from "@/components/Slider";
import Post from "@/components/Post";
import Form from "@/extensions/forms/components/Form";

export default {
  name: "ContactPage",
  extends: Page,
  components: {
    Heading,
    Slider,
    Post,
    Banner,
    Form
  }
};
</script>

<style lang="sass" scoped>
section.container
    @apply mt-8 px-4
section.map
    @apply w-full px-0
    max-width: unset!important
section.slider,
section.banners
    padding: 0
section.heading
    padding-bottom: 0
</style>
